import { DialogActions, DialogContent, DialogTitle, Step, Stepper, Typography } from '@mui/material';

import { LoaderOverlay } from '../LoaderOverlay/LoaderOverlay';
import { useWizard, UseWizardProps } from '../WizardState/hooks/useWizard/useWizard';
import { WizardState } from '../WizardState/WizardState';

import { StepLabelStyled } from './components/StepLabel/StepLabel.styled';

export interface DialogWizardProps<T> extends UseWizardProps<T> {
  title: string;
}

export const DialogWizard = <T,>({ title, ...useWizardProps }: DialogWizardProps<T>) => {
  const { steps, currentStep, contentRef, contextValue } = useWizard<T>(useWizardProps);

  const { component: CurrentComponent, actions: ActionsComponent } = steps[currentStep];

  return (
    <WizardState.Provider value={contextValue}>
      <DialogTitle marginBottom={2}>
        {title}
        <Stepper activeStep={currentStep} sx={{ position: 'relative', paddingTop: 5, paddingBottom: 3 }}>
          {steps.map(({ label, description }, index) => (
            <Step key={label}>
              {/* as per design displaying additional information only on currently active step */}
              <StepLabelStyled
                optional={
                  currentStep === index && (
                    <Typography variant="body2" sx={{ position: 'absolute', maxWidth: `calc(100% / ${steps.length})` }}>
                      {description}
                    </Typography>
                  )
                }
              >
                <Typography variant="subtitle2">{label}</Typography>
              </StepLabelStyled>
            </Step>
          ))}
        </Stepper>
      </DialogTitle>
      <DialogContent>
        <LoaderOverlay active={contextValue.loading} />
        {CurrentComponent && <CurrentComponent ref={contentRef} />}
      </DialogContent>
      <DialogActions>{ActionsComponent && <ActionsComponent />}</DialogActions>
    </WizardState.Provider>
  );
};
